import React, { useEffect, Suspense, lazy } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import PrivateSale from 'views/PrivateSale'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import Whitepaper from 'views/Whitepaper'
import CommingSoon from 'views/CommingSoon'
import Roadmap from 'views/Roadmap'
import { ResetCSS } from '@pancakeswap-libs/uikit'
import BigNumber from 'bignumber.js'
import Game from 'views/Game'
import { useFetchPublicData } from 'state/hooks'
// import Whitepaper from 'views/Whitepaper'
// import CommingSoon from 'views/CommingSoon'
// import Roadmap from 'views/Roadmap'
import GlobalStyle from './style/Global'
import Menu from './components/Menu'
import PageLoader from './components/PageLoader'
import NftGlobalNotification from './views/Nft/components/NftGlobalNotification'

// import LandingPage from './views/LandingPage'

// Route-based code splitting
// Only pool is included in the main bundle because of it's the most visited page'
const PreSale = lazy(() => import('./views/PreSale'))

const Home = lazy(() => import('./views/Home'))
const Farms = lazy(() => import('./views/Farms'))
// const Lottery = lazy(() => import('./views/Lottery'))
// const Pools = lazy(() => import('./views/Pools'))
// const Ifos = lazy(() => import('./views/Ifos'))
const NotFound = lazy(() => import('./views/NotFound'))
// const Nft = lazy(() => import('./views/Nft'))
// const Airdrop = lazy(() => import('./views/Airdrop'))

// This config is required for number formating
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

const App: React.FC = () => {
  const { account, connect } = useWallet()
  useEffect(() => {
    if (!account && window.localStorage.getItem('accountStatus')) {
      connect('injected')
    }
  }, [account, connect])
  // uncomment bottom line for farms
  useFetchPublicData()

  return (
    <Router>
      <ResetCSS />
      <GlobalStyle />
      <Menu>
        <Suspense fallback={<PageLoader />}>
          <Switch>
            <Route path="/" exact>
              {/* <Home /> */}
              <PrivateSale />
            </Route>
            {/* <Route path="/landing">
              <LandingPage />
            </Route> */}
            <Route path="/farms">
              <Farms />
            </Route>
            <Route path="/pools">
              <Farms tokenMode />
            </Route>
            <Route path="/road-map">
              <Roadmap />
            </Route>
            <Route path="/whitepaper">
              <Whitepaper />
            </Route>
            <Route path="/coming-soon">
              <CommingSoon />
            </Route>
            {/* <Route path="/presale">
              <PreSale />
            </Route>
            <Route path="/game">
              <Game />
            </Route> */}
            <Route path="/private-sale">
              <PrivateSale />
            </Route>

            {/* <Route path="/airdrop">
              <Airdrop />
            </Route> */}
            {/* <Route path="/pools"> */}
            {/*  <Pools /> */}
            {/* </Route> */}
            {/* <Route path="/lottery"> */}
            {/*  <Lottery /> */}
            {/* </Route> */}
            {/* <Route path="/ifo"> */}
            {/*  <Ifos /> */}
            {/* </Route> */}
            {/* <Route path="/nft"> */}
            {/*  <Nft /> */}
            {/* </Route> */}
            {/* Redirect */}
            {/* <Route path="/staking"> */}
            {/*  <Redirect to="/pools" /> */}
            {/* </Route> */}
            {/* <Route path="/syrup"> */}
            {/*  <Redirect to="/pools" /> */}
            {/* </Route> */}
            {/* 404 */}
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </Menu>
      {/* <NftGlobalNotification /> */}
    </Router>
  )
}

export default React.memo(App)
